module.exports = __webpack_public_path__ + "img/cz.626a83dc.svg";